import './disclaimer.less'
import Analytics from '../../SiteNav/analytics.js'

/*
 * Ameriprise Site Footer Disclaimer
 */
class AmeripriseFooterDisclaimer extends HTMLElement {
  connectedCallback() {
    this.shadow = this.attachShadow({ mode: 'open' })

    // TODO move/remove this functionality
    // this sets the Find An Advisor button href and analytics

    this.template = this.querySelector('#disclaimer-template')

    this.template &&
      this.template.content &&
      this.shadow.appendChild(this.template.content)

    /* Footer disclosures and Social Network links Analytics */
    const footerDisclaimerContent = this.shadow.querySelector(
      '.amp-footerSocialAndDisclaimer'
    )
    const disclaimerLinks =
      footerDisclaimerContent &&
      footerDisclaimerContent.getElementsByTagName('a')
    disclaimerLinks &&
      disclaimerLinks.length > 0 &&
      disclaimerLinks.forEach(link => {
        link &&
          link.addEventListener('click', event => {
            const disclaimerMessage =
              event.currentTarget && event.currentTarget.innerText
            let type = 'footer'

            try {
              const disclaimerAnalytics = new Analytics()
              disclaimerAnalytics.ping(disclaimerMessage, type)
            } catch (e) {
              console.error(e)
            }
          })
      })

    this.nortonContainer = this.shadow.querySelector('.amp-nortonPopup')

    if (this.nortonContainer) {
      this.nortonContainer.addEventListener('click', event => {
        event.preventDefault()

        const popupName = 'Norton Secured Seal'
        const targetUrl = event.currentTarget.getAttribute('href') || '/'
        const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=580,height=500,left=-1000,top=-1000`

        window.open(targetUrl, popupName, params)
      })
    }
  }
}

if (!window.customElements.get('ameriprise-footer-disclaimer')) {
  window.customElements.define(
    'ameriprise-footer-disclaimer',
    AmeripriseFooterDisclaimer
  )
}
